import Layout from "@/views/Layout";

const dynamicRoutes = [
    {
        path: '/courses-page-other/courses-page-other',
        component: Layout,
        hidden: true,
        permissions: ["courses:courses:upload"],
        children: [
            {
                path: 'UploadCoursesPage/:id',
                name: "UploadCoursesPage",
                props: true,
                component: () => import('@/views/modules/UploadCoursesPage'),
                meta: {
                    title: '上传课程',
                    activeMenu: '/CoursesPage'
                }
            }
        ]
    },
    {
        path: '/courses-page-other/courses-page-other',
        component: Layout,
        hidden: true,
        permissions: ["courses:courses:add","courses:courses:edit","courses:courses:see"],
        children: [
            {
                path: 'NewTopicsPage/:state',
                name: "NewTopicsPage",
                props: true,
                component: () => import('@/views/modules/NewTopicsPage'),
                meta: {
                    title: '新建课程',
                    activeMenu: '/CoursesPage'
                }
            }
        ]
    },
]

export default dynamicRoutes;
